export default "__VITE_ASSET__67YiN$_Q__"